import { GenerateTextInput } from 'global/textGenApi';

import { AiTextToolFormSubmitOptions } from '../aiTextToolForm/types';

export const formatDynamicOptions = ({
  formData,
  formSchema,
  mainUserPrompt,
}: AiTextToolFormSubmitOptions): GenerateTextInput['dynamicOptions'] => {
  const dynamicOptions: GenerateTextInput['dynamicOptions'] = [
    {
      name: formSchema.textArea.label ?? '',
      value: mainUserPrompt,
    },
  ];
  for (const formField of formSchema.fields) {
    const userInput = formData[formField.key];

    const isNonEmpty = userInput || userInput === false;
    if (isNonEmpty && formField.label) {
      dynamicOptions.push({
        name: formField.label,
        value: `${userInput}`,
      });
    }
  }

  return dynamicOptions;
};
